import { defaultDataIdFromObject } from "@apollo/client";

export const redefinedTypes = [
  "OptInOptOutOfActiveCampaign",
  "ExpertsProgram",
  "CampaignInterface"
];

const dataIdFromObject = (responseObject, options) => {
  let id;

  switch (options.typename) {
    case "OptInOptOutOfActiveCampaign":
    case "ExpertsProgram":
      id = "ExpertsProgram:Root";
      break;
    case "CampaignInterface":
      id = "ExpertCampaign:Root";
      break;
    default:
      id = defaultDataIdFromObject(responseObject);
  }

  if (process.env.SHOW_EXPERTS_DEV) {
    if (!id) {
      // eslint-disable-next-line no-console
      console.warn("NO DATA ID", options.typename, responseObject);
    } else {
      // eslint-disable-next-line no-console
      console.log("DATA ID", id, responseObject);
    }
  }

  return id;
};

export default dataIdFromObject;
